import React, {useContext} from "react";
import ReactDom from "react-dom";
import { keyContext } from '../KeyContext'


const Modal = ({ open, children }) => {
      const {leftMargin} = useContext(keyContext)
      const clientHeight =document.getElementById('tes')?  document.getElementById('tes').clientHeight : '1380px'
      const windowHeight = window.innerHeight
    // console.log(clientHeight, 'client height')
     if (!open) return null;
     return (
    <>
      <div style={{position:'fixed',display:'flex',justifyContent:'center',top: windowHeight > 1000 ? '69px' : '0px',left:leftMargin,width:windowHeight > 1000 ? '1858px': '1920px',height:'94vh', backgroundColor:'rgba(0,0,0,0.5)',zIndex:100,overflowY:'auto'}}>
        {children}
      </div>
    </>
  );
};

export default Modal;